import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMaterialTileRoof = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "material-tile-roof" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M22.533,23.25a.68.68,0,0,0,.678-.746L21.164,2.1A1.5,1.5,0,0,0,19.672.75H4.328A1.5,1.5,0,0,0,2.836,2.1L.789,22.5a.68.68,0,0,0,.678.746"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M1.467,23.25a3.01,3.01,0,0,1,5.958-.6.752.752,0,0,0,.738.6h.151a.752.752,0,0,0,.737-.6,3.012,3.012,0,0,1,5.9,0,.751.751,0,0,0,.738.6h.151a.752.752,0,0,0,.737-.6,3.01,3.01,0,0,1,5.958.6"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.238,
			y1: 23.25,
			x2: 8.99,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15.762,
			y1: 23.25,
			x2: 15.01,
			y2: .75
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.529,14.545A3.934,3.934,0,0,1,12,12.75a4.1,4.1,0,0,1,3.468,1.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.468,14.454a3.791,3.791,0,0,1,3.3-1.7,3.888,3.888,0,0,1,3.672,2.108"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.532,14.454a3.791,3.791,0,0,0-3.3-1.7,3.888,3.888,0,0,0-3.672,2.108"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.749,7.8A3.63,3.63,0,0,1,12,6a3.762,3.762,0,0,1,3.248,1.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.248,7.7A3.5,3.5,0,0,1,18.342,6a3.594,3.594,0,0,1,3.425,2.108"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.752,7.7A3.5,3.5,0,0,0,5.658,6,3.594,3.594,0,0,0,2.233,8.108"
		})
	]
});
export default SvgMaterialTileRoof;
